import { CtaButton } from '@tkww/orion-web-ds-action';
import classnames from 'classnames';
import React from 'react';
import type { ReactNode } from 'react';
import Styles from './styles.scss';

export interface BaseFilterPillProps {
	/** Text to display on the button */
	label: string;
	/** Click handler for the button */
	onClick: () => void;
	/** Whether the filter is currently active */
	isActive?: boolean;
	/** Additional CSS class names to apply */
	className?: string;
	/** Optional content to render below the button (e.g., dropdown menu) */
	children?: ReactNode;
	/** Optional ref for the container */
	containerRef?: React.RefObject<HTMLDivElement>;
	/** Whether the filter has selected filters applied (used for styling) */
	hasSelectedFilters?: boolean;
}

/**
 * BaseFilterPill - A generic filter pill component that provides common styling
 * and behavior for review filter buttons.
 */
export const BaseFilterPill = ({
	label,
	onClick,
	isActive = false,
	className,
	children,
	containerRef,
	hasSelectedFilters,
}: BaseFilterPillProps) => {
	const styleType = hasSelectedFilters
		? 'primary-alternative'
		: 'secondary-alternative';

	return (
		<div ref={containerRef} className={Styles.pillContainer}>
			<CtaButton
				className={classnames(
					{
						[Styles.active]: isActive,
					},
					className,
				)}
				onClick={onClick}
				styleType={styleType}
				size="sm"
			>
				{label}
			</CtaButton>
			{children}
		</div>
	);
};
